<template>
    <div>
        <div class="button-group">
            <el-button-group>
                <el-tooltip
                    class="item"
                    effect="dark"
                    content="重置"
                    placement="top"
                >
                    <el-button
                        type="primary"
                        icon="el-icon-refresh-right"
                        @click="onChangUUID"
                    ></el-button>
                </el-tooltip>
            </el-button-group>
        </div>
        <div class="g-card">
            <span>{{ uuid.toLowerCase() }}</span>
            <div class="copy">
                <el-button
                    size="mini"
                    round
                    icon="el-icon-document-copy"
                    v-clipboard:copy="uuid.toLowerCase()"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                ></el-button>
            </div>
        </div>
        <div class="g-card">
            <span>{{ uuid }}</span>
            <div class="copy">
                <el-button
                    size="mini"
                    round
                    icon="el-icon-document-copy"
                    v-clipboard:copy="uuid"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                ></el-button>
            </div>
        </div>
    </div>
</template>

<script>
import guid from "./guid";
export default {
    name: "g-uuid",
    data() {
        return {
            uuid: "",
        };
    },
    methods: {
        onChangUUID() {
            this.uuid = guid(false, false);
        },
        // 复制成功时的回调函数
        onCopy(e) {
            this.$message.success("内容已复制到剪切板！");
        },
        // 复制失败时的回调函数
        onError(e) {
            this.$message.error("抱歉，复制失败！");
        },
    },
    mounted() {
        this.uuid = guid(false, false);
    },
};
</script>
<style scoped>
.button-group {
    text-align: center;
}
</style>
